import React, { Component, PropTypes } from 'react';
import {reduxForm} from "redux-form";
import {getSettings, editSettings} from '../../actions/index';


class Settings extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.changeSelect = this.changeSelect.bind(this);
        this.renderSelect = this.renderSelect.bind(this);
        this.SubmitForm = this.SubmitForm.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.getSettings(token);
    }
    componentDidMount(){
        let token = localStorage.getItem('id_token_admin');
        $('.selectpicker').selectpicker();
    }
    changeSelect(e){
        this.props.fields[e.target.name].onChange(e.target.value)
    }
    renderSelect(id){
        if(id == 'negative'){
            this.props.settings.setting.negative_sequence_history.forEach((item, index)=>{
                if($('#'+id).find('option#'+index).length){
                    return false
                }else{
                    $('#'+id).append($('<option>', {
                        value: item,
                        text : item,
                        id : index
                    }));
                }
            });
        }else{
            this.props.settings.setting.positive_sequence_history.forEach((item, index)=>{
                if($('#'+id).find('option#'+index).length){
                    return false
                }else{
                    $('#'+id).append($('<option>', {
                        value: item,
                        text : item,
                        id : index
                    }));
                }
            });
        }
        $('.selectpicker').selectpicker('refresh');
    }
    SubmitForm(props){
        let token = localStorage.getItem('id_token_admin');
        this.props.editSettings(token, props).then((response)=>{
            this.props.getSettings(token);
            $('.selectpicker').selectpicker('refresh');
        })
    }
    render() {
        const { fields: {
            sentence_success_percent,
            speak_part_percent,
            negative_sequence,
            positive_sequence}, handleSubmit} = this.props;
        return (
            <form onSubmit={handleSubmit(this.SubmitForm.bind(this))}>
                <div className="dashboard-wrapper">
                    <p className="dashboard-title">Settings</p>
                    <div>
                        <div className="col-md-12">
                            <div className="white-block block-4-8 clearfix">

                                <div className="clearfix">
                                    <div className="col-md-4">
                                        <label htmlFor="sentence_success_percent">Sentence success percent</label>
                                    </div>
                                    <div className={ sentence_success_percent.touched && !sentence_success_percent.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                        <input type="text"
                                               placeholder=""
                                               className="form-control"
                                               name="sentence_success_percent"
                                               id="sentence_success_percent"
                                            {...sentence_success_percent}
                                        />
                                    </div>
                                </div>
                                <div className="clearfix">
                                    <div className="col-md-4">
                                        <label htmlFor="speak_part_percent">Persentage showed as a Hint</label>
                                    </div>
                                    <div className={ speak_part_percent.touched && !speak_part_percent.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                        <input type="text"
                                               placeholder=""
                                               className="form-control"
                                               name="speak_part_percent"
                                               id="speak_part_percent"
                                            {...speak_part_percent}
                                        />
                                    </div>
                                </div>
                                <div className="clearfix">
                                    <div className="col-md-4">
                                        <label htmlFor="negative_sequence">Negative sequence</label>
                                    </div>
                                    <div className={ negative_sequence.touched && !negative_sequence.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                        <div className="input-half pull-left">
                                            <input type="text"
                                                   placeholder="Add negative sequence"
                                                   className="form-control"
                                                   name="negative_sequence"
                                                   id="negative_sequence"
                                                {...negative_sequence}
                                            />
                                        </div>
                                        <p className="input-separator pull-left">or</p>
                                        <div className="input-half pull-right">
                                            <select className="selectpicker" id="negative" name="negative_sequence" defaultValue="defaultSelect" data-live-search="true" onChange={this.changeSelect}>
                                                <option value="defaultSelect">Choose negative sequence</option>
                                                {this.props.settings.setting && this.props.settings.setting.negative_sequence_history ? this.renderSelect('negative') : ""}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix">
                                    <div className="col-md-4">
                                        <label htmlFor="positive_sequence">Positive sequence</label>
                                    </div>
                                    <div className={ positive_sequence.touched && !positive_sequence.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                        <div className="input-half pull-left">
                                            <input type="text"
                                                   placeholder="Add positive sequence"
                                                   className="form-control"
                                                   name="positive_sequence"
                                                   id="positive_sequence"
                                                {...positive_sequence}
                                            />
                                        </div>
                                        <p className="input-separator pull-left">or</p>
                                        <div className="input-half pull-right">
                                            <select className="selectpicker" id="positive" name="positive_sequence" defaultValue="defaultSelect" data-live-search="true" onChange={this.changeSelect}>
                                                <option value="defaultSelect">Choose positive sequence</option>
                                                {this.props.settings.setting && this.props.settings.setting.positive_sequence_history ? this.renderSelect('positive') : ""}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 block-4-8-title mb20 mt20"></div>
                                <div className="col-md-12 text-center button-group">
                                    <button type="submit" className="btn btn-primary">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </form>
        );
    }
}

function validate(values) {
    const errors = {};
    if(!values.sentence_success_percent){
        errors.sentence_success_percent = 'Enter a first_name'
    }
    if(!values.speak_part_percent){
        errors.speak_part_percent = 'Enter a last_name'
    }
    if(!values.negative_sequence){
        errors.negative_sequence = 'Enter a email'
    }
    if(!values.positive_sequence){
        errors.positive_sequence = 'Enter a title'
    }
    return errors;
}

function  mapStateToProps(state) {
    return{
        settings: state.settings,
        initialValues: {
            sentence_success_percent: state.settings.setting.sentence_success_percent || '',
            speak_part_percent: state.settings.setting.speak_part_percent || '',
            negative_sequence: state.settings.setting.negative_sequence || '',
            positive_sequence: state.settings.setting.positive_sequence || ''
        }
    }
}
export default reduxForm({
    form: 'Settings',
    fields: ['sentence_success_percent', 'speak_part_percent', 'negative_sequence', 'positive_sequence' ],
    validate
}, mapStateToProps, {getSettings, editSettings})(Settings);


// WEBPACK FOOTER //
// ./src/components/settings/settings.js